import React, { useState } from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { Accordion, AccordionTheme } from 'wix-ui-tpa/cssVars';
import { SingleSlotDetailsDataHook } from './dataHooks';
import { classes } from './MoreDetails.st.css';

export type ExpandableDetailsProps = {
  children: React.ReactNode;
};

/**
 * "More details" / "Less details" toggle. The content is rendered above the toggle while
 * expanded (so the toggle stays at the bottom) and inside the collapsed accordion item
 * otherwise, which keeps the accordion's open/close animation.
 */
export const ExpandableDetails: React.FC<ExpandableDetailsProps> = ({
  children,
}) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      {isExpanded && children}
      <Accordion
        className={classes.accordion}
        data-hook={SingleSlotDetailsDataHook.MORE_DETAILS_ACCORDION}
        onItemClick={(_id: string, isItemExpanded: boolean) =>
          setIsExpanded(isItemExpanded)
        }
      >
        <Accordion.Item
          id="more-details-section"
          title={t(
            isExpanded
              ? 'app.bookings-form.bookings-details.less-details.title'
              : 'app.bookings-form.bookings-details.more-details',
          )}
          theme={AccordionTheme.Line}
        >
          {!isExpanded && children}
        </Accordion.Item>
      </Accordion>
    </>
  );
};
